<template>
  <div>
    <div class="pointsDetails div-layout">
      <div v-if="!hiddenVariable.dialogEditVisible">
        <module-title title="用户管理" />
        <div>
          <el-form
            ref="subjectSearchForm"
            :model="searchForm"
            :inline="true"
            label-position="right"
            label-width="100px"
          >
            <el-form-item label="手机号：" prop="phone">
              <el-input
                v-model="searchForm.phone"
                name="phone"
                maxlength="11"
                placeholder="输入手机号"
                class="handle-form-input"
                clearable
              />
            </el-form-item>

            <el-form-item label="用户来源：" prop="productCode">
              <el-select
                v-model="searchForm.productCode"
                name="productCode"
                size="medium"
                class="edit-form-input"
              >
                <el-option key="" label="全部" value="" />
                <el-option
                  v-for="item in appCodeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="handleSearchFilter"
              >
                查询
              </el-button>
            </el-form-item>
          </el-form>
          <el-table
            v-loading="listLoading"
            :data="userManageList"
            highlight-current-row
            fit
            element-loading-text="Loading"
            class="list-table"
          >
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="手机号" align="center" prop="phone" />
            <el-table-column label="会员等级" prop="level" align="center">
              <template slot-scope="scope">
                <p v-for="item in levelList" v-show="scope.row.level===item.id" :key="item.id">
                  {{ item.name }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="用户来源" prop="productName" align="center" />
            <el-table-column label="会员有效期始" prop="beginTime" align="center" />
            <el-table-column label="会员有效期末" prop="endTime" align="center" />
            <el-table-column label="积分" prop="value" align="center" />
            <el-table-column label="操作" align="center" width="320px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="opAddOrEdit('points',scope.row)"
                >
                  积分明细
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  @click="opAddOrEdit('interest',scope.row)"
                >
                  权益明细
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  @click="opAddOrEdit('address',scope.row)"
                >
                  收货地址
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchForm.total"
            :page.sync="searchForm.pageNum"
            :limit.sync="searchForm.pageSize"
            @pagination="pageCurriculumList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
      <div v-else>
        <interest-details v-if="hiddenVariable.type==='interest'" :user-props="userPropsList" @close="handleGoback" />
        <points-details v-if="hiddenVariable.type==='points'" :user-props="userPropsList" @close="handleGoback" />
        <shipping-address v-if="hiddenVariable.type==='address'" :user-props="userPropsList" @close="handleGoback" />
      </div>
    </div>
  </div>
</template>

<script>

import InterestDetails from './interestDetails';
import PointsDetails from './pointsDetails';
import ShippingAddress from './shippingAddress';
import { getUsersList } from '@/api/userManagement/index/';
import {
  getDictsType
} from '@/api/productOperation/public/advertisementManage';
export default {
  name: 'PortraitManage',
  components: {
    InterestDetails,
    PointsDetails,
    ShippingAddress
  },
  data() {
    return {
      dictsType: 'user_source',
      appCodeList: [],
      userPropsList: {},
      // 搜索表单
      searchForm: {
        productTerminal: '',
        advertisementPosition: '',
        advertisementType: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      userManageList: [],
      listLoading: false, // 表格刷新loading
      hiddenVariable: {
        dialogEditVisible: false,
        type: ''

      },
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7 || time.getTime() < Date.now() - 3 * 31 * 24 * 60 * 60 * 1000 - 8.64e7; // 如果有后面的-8.64e7就是不可以选择今天
        }
      }
    };
  },
  computed: {
    levelList() {
      return [
        {
          id: 0,
          name: '普通会员'
        },
        {
          id: 1,
          name: '付费会员'
        }
      ];
    }
  },
  mounted() {
    this.getType();
    this.fetchUserManageList();
  },
  methods: {
    getType() {
      getDictsType(this.dictsType).then(res => {
        this.appCodeList = res.data;
      });
    },
    // 获取积分明细数据
    fetchUserManageList() {
      this.listLoading = true;
      var option = {
        phone: this.searchForm.phone,
        productCode: this.searchForm.productCode,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      getUsersList(option).then((res) => {
        if (res.data && res.data.list && res.data.list.length) {
          this.userManageList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.userManageList = [];
          this.searchForm.total = 0;
        }
        this.listLoading = false;
      }).catch((err) => {
        console.log(err);
        this.userManageList = [];
        this.total = 0;
        this.listLoading = false;
      });
    },

    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchUserManageList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchUserManageList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchUserManageList();
    },
    opAddOrEdit(type, row) {
      this.hiddenVariable.dialogEditVisible = true;
      this.hiddenVariable.type = type;
      this.userPropsList = row;
    },
    handleGoback() {
      this.hiddenVariable.dialogEditVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.pointsDetails {
  padding-bottom: 20px;
}
.edit-form-input {
  width: 150px;
}
.edit-form-time{
   width: 300px;
}
</style>
